import { type CSSProperties, type ReactNode } from 'react'
import { XCircle } from 'phosphor-react'
import * as AlertDialog from '@radix-ui/react-alert-dialog'
import clsx from 'clsx'

type DialogModalProps = {
  title?: string
  isOpen: boolean
  children: ReactNode
  onClose?: () => void
  styleBox?: CSSProperties | undefined
}

export const DialogModal = ({
  title,
  isOpen,
  children,
  styleBox,
  onClose,
}: DialogModalProps) => {
  return (
    <AlertDialog.Root open={isOpen}>
      <AlertDialog.Portal>
        <AlertDialog.Overlay className="fixed inset-0 z-50 bg-gray-500 bg-opacity-50" />
        <AlertDialog.Content
          className="fixed z-50 w-10/12 max-w-md -translate-x-1/2 -translate-y-1/2 bg-white rounded-lg top-1/2 left-1/2 "
          style={styleBox}
        >
          <div
            className={clsx('flex items-center justify-between px-4 py-5', {
              'border-b border-grey-500': Boolean(title),
            })}
          >
            {title && (
              <AlertDialog.Title className="font-medium break-all">
                {title}
              </AlertDialog.Title>
            )}
            {onClose && (
              <button className="ml-auto" onClick={onClose}>
                <XCircle size={24} className="text-grey-700" />
              </button>
            )}
          </div>

          <div>{children}</div>
        </AlertDialog.Content>
      </AlertDialog.Portal>
    </AlertDialog.Root>
  )
}
